'use strict';

var React = require('react');

var SvgCollectionIcon = function SvgCollectionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.25c0-.414-.336-.75-.75-.75h-3.029c-.87 0-1.703.348-2.313.968l-4.692 4.755c-.29.295-.288.77.007 1.06.295.292.77.289 1.06-.006l4.693-4.756c.328-.333.777-.521 1.245-.521h3.029c.414 0 .75-.336.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.5c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.767 6.098c.703-.703 1.657-1.098 2.652-1.098h2.081c1.519 0 2.75 1.231 2.75 2.75v2.289c0 .861-.342 1.688-.952 2.298l-4.206 4.206c-.976.976-2.56.976-3.536 0l-2.672-2.672c-1.074-1.075-1.074-2.816 0-3.89l3.883-3.883Zm2.652.402c-.597 0-1.17.237-1.591.659l-3.883 3.883c-.489.488-.489 1.28 0 1.768l2.672 2.672c.39.39 1.024.39 1.414 0l4.206-4.206c.329-.328.513-.773.513-1.237v-2.289c0-.69-.56-1.25-1.25-1.25h-2.081Z"
  }));
};
SvgCollectionIcon.displayName = "CollectionIcon";

exports.SvgCollectionIcon = SvgCollectionIcon;
